:where(.container) {
  border-bottom: 1px solid var(--dds-color-border-default);
}

:where(.container:first-child) {
  border-top: 1px solid var(--dds-color-border-default);
}

:where(.header-button) {
  @media (prefers-reduced-motion: no-preference) {
    transition:
      background-color var(--dds-motion-micro-state),
      var(--dds-focus-transition);
  }

  color: inherit;

  &:hover {
    background-color: var(--dds-color-surface-hover-default);
    .chevron {
      color: var(--dds-color-text-action-hover);
    }
  }
}

.chevron {
  margin-inline-end: var(--dds-spacing-x0-5);
}
